!function(t){t(window).one("scroll mousemove",function(){t(".lazy-image").each(function(){t(this).attr("src",t(this).attr("data-src"))})})}(jQuery);